import { Box, Typography } from '@mui/material';
// Components
import ListIcon from './ListIcon';
// Contexts
import { useStoreContext } from '@/providers/StoreProvider';
// Utils
import { config } from 'config';
import { brand } from '@/brand/brand';
import { formatAmount } from '@/utils/index';

const minimumPurchase = brand.referralMinimumSmartNodePurchase ?? '$2,000';

const listText = (smartNodeName: string) => [
  'Referrals will receive a FREE wallet and a FREE licensed node upon creation of a new account.',
  'For the first three referrals that sign up using your unique, shareable offer link, you will receive a FREE licensed node (3 free nodes max per account).',
  `For the first three referrals that sign up using your unique, shareable offer link, you will receive a credit of $${
    config.brand.offerCreditAmount || '100'
  } towards the purchase of a ${smartNodeName} (3 free credits max per account, minimum ${minimumPurchase} purchase required).`,
];

const fallbackSubTitle = `Earn 3 FREE licensed nodes and up to $${formatAmount(
  +config.brand.offerCreditAmount || 100
)} off the purchase of a SmartNode by sharing this exclusive offer today!`;

const ListItem = ({ content, listNumber }) => (
  <Box sx={{ display: 'flex', gap: '8px' }}>
    <ListIcon content={`${listNumber}`} />
    <Typography variant="body1">{content}</Typography>
  </Box>
);

export default function NodeOffer({ items, subTitle }): JSX.Element {
  const { smartNode }: any = useStoreContext();
  const smartNodeName = smartNode?.name || 'SmartNode';
  const renderList = items.length ? items : listText(smartNodeName);
  return (
    <Box
      sx={{
        marginBottom: '24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {renderList.map((content, i) => (
        <ListItem key={i} listNumber={i + 1} content={content?.title ?? content} />
      ))}
      <Box>
        <Typography variant="body1">{subTitle ?? fallbackSubTitle}</Typography>
      </Box>
    </Box>
  );
}
